<script>
import { mapGetters } from 'vuex';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';

export default {
  name: 'AvContractBasicInfoForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
    RbxDatePicker,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDateInput(newDate) {
      this.avContract.date = newDate;
    },
    cleanPrincipal() {
      this.avContract.principal = null;
    },
    cleanContractor() {
      this.avContract.contractor = null;
    },
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.name')" xs6 md4>
            <v-text-field
              v-model="avContract.name"
              label="Bezeichnung des AV-Vertrags"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.organizationalUnit')" xs6 md4>
            <rbx-remote-combobox
              v-model="avContract.organizationalUnit"
              label="Organisationseinheit"
              :selected="avContract.organizationalUnit"
              domain="organizationalUnit"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.responsibleUser')" xs6 md4>
            <rbx-remote-combobox
              v-model="avContract.responsibleUser"
              label="Fachverantwortlicher für diesen AV-Vertrag"
              :selected="avContract.responsibleUser"
              domain="user"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.principal')" xs6 md2 py-0>
            <rbx-remote-combobox
              v-model="avContract.principal"
              label="Auftraggeber"
              :selected="avContract.principal"
              :disabled="avContract.isClientPrincipal"
              domain="affiliate"
            />
          </v-flex>

          <v-flex xs6 md2 py-0>
            <v-checkbox
              v-model="avContract.isClientPrincipal"
              label="Mandant selbst"
              class="caption"
              @click.native="cleanPrincipal"
              hide-details
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.contractor')" xs6 md2 py-0>
            <rbx-remote-combobox
              v-model="avContract.contractor"
              label="Auftragnehmer"
              :selected="avContract.contractor"
              :disabled="avContract.isClientContractor"
              domain="affiliate"
            />
          </v-flex>

          <v-flex xs6 md2 py-0>
            <v-checkbox
              v-model="avContract.isClientContractor"
              label="Mandant selbst"
              class="caption"
              @click.native="cleanContractor"
              hide-details
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.contractorDelegate')" xs6 md2 py-0>
            <rbx-remote-combobox
              v-model="avContract.contractorDelegate"
              label="Vertreter Auftragnehmer"
              :selected="avContract.contractorDelegate"
              domain="affiliate"
              :disabled="avContract.isDelegateUnderDsgvo"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.isDelegateUnderDsgvo')" xs6 md2 py-0>
            <v-switch
              v-model="avContract.isDelegateUnderDsgvo"
              label="Vertreter gemäß Art. 27 DS-GVO"
              height="0"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.toms')" md4 py-0>
            <rbx-remote-combobox-multiple
              v-model="avContract.toms"
              :selected="avContract.toms"
              searchable
              domain="tom"
              label="TOMs" />
          </v-flex>
          <v-flex v-if="isFieldVisible('avContract.date')" md4 py-0>
            <rbx-date-picker label="Datum" :value="avContract.date" @input="onDateInput" />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.transferOfficers')" xs12 md8 py-0>
            <v-textarea
              v-model="avContract.transferOfficers"
              label="Weisungsbefugte"
              class="caption"
            />
          </v-flex>

          <v-flex xs12 md12/>

          <v-flex v-if="isFieldVisible('avContract.isTemplate')" md2 py-0>
            <v-switch
              v-model="avContract.isTemplate"
              label="Vorlage"
              height="0"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('avContract.isDelete')" md2 py-0>
            <v-switch
              v-model="avContract.isDelete"
              label="Gelöscht"
              height="0"
              :readonly="!auth.hasDeleteRights"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
